import React from "react";
import ReactDOM from "react-dom";
import App from "~/common/App";
import { OnTheMoveProvider } from "~/common/hooks/OnTheMoveContext";
import ErrorBoundary from "~/components/common/ErrorBoundary";

ReactDOM.render(
    <React.Suspense>
        <ErrorBoundary>
            <OnTheMoveProvider>
                <App />
            </OnTheMoveProvider>
        </ErrorBoundary>
    </React.Suspense>,
    document.getElementById("root")
);